import { getFile } from "sr/utils/api/getFile"

interface paramsType  {
files?:[],
setPreviewImages?:(item)=> void,
previewImages?:[],
type?:string,
previewVideo?:[]
setPreviewVideo?:(item)=> void
setLoader?:(bool)=> void
}
const fetchFile = async (key) => {
    const res = await getFile(key)
    if(res) {
        return res
    }
}
export const setPreview = async (params:paramsType)=> {
    try {
    params?.setLoader(true)
    if (params?.files?.length) {
        const videos = []
        const images = []
               for (const item of params?.files) {
            const data = await fetchFile(item)
            if(params?.type==='images'){
                images.push({blob:URL.createObjectURL(data), key:item })
            params?.setLoader(false)
            }
         if(params?.type==='videos'){
           videos.push({blob:URL.createObjectURL(data), key:item })
            params?.setLoader(false)
         }
               }
               if(params?.type==='images'){
                
                params?.setPreviewImages(images)
               }
                if(params?.type==='videos'){
                        params?.setPreviewVideo(videos)
                }
    }
    }
catch(e){

    params?.setLoader(false)
        }
    }